import { Controller } from '@hotwired/stimulus'

export default class RedirectController extends Controller {
  static values = {
    domain: String,
    enabledRedirect: Boolean,
  }

  declare domainValue: string
  declare enabledRedirectValue: boolean

  connect() {
    if (!this.enabledRedirectValue) return

    window.location.href = `https://${this.domainValue}.com${window.location.pathname}${window.location.search}`
  }
}
